var divider_viewer_rtlignore_default = {
  "divider-container": "sDdA7",
  "divider-container--double": "r-KvT",
  "divider": "tc33l",
  "divider--single": "VLo6m",
  "divider--double": "vcOQX",
  "divider--dashed": "Vbh-G",
  "divider--dotted": "tCVYR",
  "divider--small": "EM-q-",
  "divider--small--mobile": "BcYrN",
  "divider--medium": "tp2zK",
  "divider--large--mobile": "zMKKc",
  "divider--medium--mobile": "rMVzv",
  "divider--large": "Bv6H9",
  "divider--left": "_9K4m2",
  "divider--center": "fk8NK",
  "divider--right": "nMj70",
  "divider--fill-parent": "s--jI",
  "svgFixerContainer": "NVrgr",
  "emptyChar": "Jtym8"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
